export function go(path: string) {
  location.hash = path;
}
